import React from 'react';
import './price.scss';
import { categories } from '../../../data/categories';
import { services } from '../../../data/services';

type categoryType = {
    id: number, 
    title: string
}

type serviceType = {
    id: number;
    category_id: number;
    title: string;
    price: {
        cat: string;
        cat_price_1: number | string;
        cat_price_2: number | string;
        cat_price_3: number | string;
    }[];
}

export function Price() {
  const data = categories.map((cat: categoryType) => {
    let serviceList = services.filter((service: serviceType) => service.category_id === cat.id).map((serv: serviceType) => {
        return serv.price.map((item: any) => {
            return <tr>
                     <td>{(item.cat === 'Кат 1' || item.cat === '') ? serv.title : ''}</td>
                     <td>{item.cat}</td>
                     <td>{item.cat_price_1 !== 0 ? (item.cat_price_1).toLocaleString('ru') : ''}</td>
                     <td>{item.cat_price_2 !== 0 ? (item.cat_price_2).toLocaleString('ru') : ''}</td>
                     <td>{item.cat_price_3 !== 0 ? (item.cat_price_3).toLocaleString('ru') : ''}</td>
                   </tr>
        })
    })
    return <tbody>
             <tr>
                <th colSpan={5} className='thead'>{cat.title}</th>
             </tr>
             <tr>
                <th className='tsubhead'>услуга</th>
                <th colSpan={4} className='tsubhead'>цена (руб.)</th>
             </tr>
             {serviceList}
            </tbody>
  });
  return (
    <section id="price">
      <h2 className='title'>Услуги и цены</h2>
      <table className='table table-sm table-hover table'>
        {data}
      </table>
      <p>Прейскурант на ветеринарные услуги Ветеринарный центр «НАОЛИ» действует с 01.01.2023</p>
    </section>
  );
}
